import { TAttachmentDTOCamelCased, TAttachmentOnClient } from '@entities/attachment/model/types';

export enum Step {
    SELECT = 'select',
    NEWSLETTER = 'broadcast',
    SURVEY = 'survey',
}

export interface IModalForm {
    title: string;
    attachment: (TAttachmentOnClient | TAttachmentDTOCamelCased)[];
    link: string;
    description: string;
    history: boolean;
    comment: string;
    primaryText: string;
    secondaryText: string;
    primaryLink: string;
    secondaryLink: string;
}
